import * as Mui from "@mui/material";
import useOperationTranslation from "../../hooks/useOperationTranslation";
import { ContextDamageForm } from "./DamageFormContext";
import { useContext} from "react";

type Props = {
  onClickCancel: () => void;
  onClickSave?: () => void;
}

const SectionCardActions = (props: Props) => {
  const t = useOperationTranslation();

  const damageFormContext = useContext(ContextDamageForm);

  return (
    <Mui.DialogActions>
      <Mui.Grid container spacing={2} justifyContent="end">
          <Mui.Grid item xs={12} sm={3} lg={2}>
              <Mui.Button variant="outlined" onClick={props.onClickCancel} fullWidth disabled = {damageFormContext.generalInfo?.migrated}>
                  <Mui.Typography variant="h6" color={'accent'}>
                      {t("damageForm.details.common.cardActionsSection.btnCancel")}
                  </Mui.Typography>
              </Mui.Button>
          </Mui.Grid>

          <Mui.Grid item xs={12} sm={3} lg={2}>
              <Mui.Button onClick={props.onClickSave} fullWidth type="submit" disabled = {damageFormContext.generalInfo?.migrated}>
                  <Mui.Typography variant="h6" color={'accent'}>
                      {t("damageForm.details.common.cardActionsSection.btnSave")}
                  </Mui.Typography>
              </Mui.Button>
          </Mui.Grid>
      </Mui.Grid>
    </Mui.DialogActions>
  )
}

export default SectionCardActions;